import { TenantDriverDto } from '@splitsecondconnect/ultramarine-shared';

import { dateCast } from '../functions/sectionCasters.function';

export function mapDriverDtoToModel(x: TenantDriverDto | null): any {
	if (!x) {
		return {
			driverId: null,
			driverIdentityDocumentType: null,
			driverIdentityDocumentNumber: null,
			driverIdentityDocumentIssueDate: null,
			driverIdentityDocumentExpiryDate: null,
			driverIdentityDocumentIssuedByCountryId: null,
			driverDrivingLicenseNumber: null,
			driverDrivingLicenseCategory: null,
			driverDrivingLicenseIssueDate: null,
			driverDrivingLicenseExpiryDate: null,
			driverDrivingLicenseIssuedByCountryId: null,
		};
	}

	return {
		driverId: x.id,
		driverIdentityDocumentType: x.identityDocumentType ?? null,
		driverIdentityDocumentNumber: x.identityDocumentNumber ?? null,
		driverIdentityDocumentIssueDate: dateCast(x.identityDocumentIssueDate),
		driverIdentityDocumentExpiryDate: dateCast(x.identityDocumentExpiryDate),
		driverIdentityDocumentIssuedByCountryId:
			x.identityDocumentIssuedByCountryId ?? null,
		driverDrivingLicenseNumber: x.drivingLicenseNumber ?? null,
		driverDrivingLicenseCategory: x.drivingLicenseCategory ?? null,
		driverDrivingLicenseIssueDate: dateCast(x.drivingLicenseIssueDate),
		driverDrivingLicenseExpiryDate: dateCast(x.drivingLicenseExpiryDate),
		driverDrivingLicenseIssuedByCountryId:
			x.drivingLicenseIssuedByCountryId ?? null,
	};
}

export function mapDriverModelToDto(x: any): any {
	return {
		driver: {
			id: x.driverId,
			identityDocumentType: x.driverIdentityDocumentType ?? null,
			identityDocumentNumber: x.driverIdentityDocumentNumber ?? null,
			identityDocumentIssueDate: dateCast(x.driverIdentityDocumentIssueDate),
			identityDocumentExpiryDate: dateCast(x.driverIdentityDocumentExpiryDate),
			identityDocumentIssuedByCountryId:
				x.driverIdentityDocumentIssuedByCountryId ?? null,
			drivingLicenseNumber: x.driverDrivingLicenseNumber ?? null,
			drivingLicenseCategory: x.driverDrivingLicenseCategory ?? null,
			drivingLicenseIssueDate: dateCast(x.driverDrivingLicenseIssueDate),
			drivingLicenseExpiryDate: dateCast(x.driverDrivingLicenseExpiryDate),
			drivingLicenseIssuedByCountryId:
				x.driverDrivingLicenseIssuedByCountryId ?? null,
		},
	};
}

export function mapDriverIdToDriverDto(driverIds: number[]): {
	drivers: TenantDriverDto[];
} {
	const result = driverIds?.map((id) => {
		return {
			id: id,
		};
	});
	return {
		drivers: result,
	};
}
